import React, { useEffect, useState } from 'react';
import css from './mailChimpForm.module.css';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import { loadMailchimpScript, removeMailchimpScript } from '../../util/loadMailChimp';

const MailchimpSubscribe = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  useEffect(() => {
    loadMailchimpScript(true);
    return () => {
      removeMailchimpScript(false);
    };
  }, []);
  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [successMessage]);
  const validateEmail = (value) => {
    if (!value || value.trim().length === 0) return 'Email is required';

    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!emailRe.test(value)) return 'Please enter a valid email';

    const fakeDomains = [
      'yopmail.com', '10minutemail.com', 'guerrillamail.com', 'mailinator.com',
      'temp-mail.org', 'throwaway.email', 'tempmail.net', 'getnada.com',
      '0-mail.com', '10minutemail.net', '20minutemail.com', 'guerrillamailblock.com',
      'spam4.me', 'tempail.com', 'tempemail.com', 'temporaryemail.net',
      'throwawaymail.com', 'trashmail.com', 'guerrillamail.net', 'guerrillamail.org'
    ];

    const domain = value.toLowerCase().split('@')[1];
    if (fakeDomains.includes(domain)) {
      return 'Please use a valid email address';
    }
    return null;
  };
  const handleBlur = () => {
    const err = validateEmail(email);
    setError(err);
  };
  const handleChange = e => {
    setEmail(e.target.value);
    if (error) {
      const err = validateEmail(e.target.value);
      setError(err);
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    const err = validateEmail(email);
    if (err) {
      setError(err);
      return;
    }
    setLoading(true);
    setError('');
    setSuccessMessage('');
    const form = e.target;
    const formData = new FormData(form);
    try {
      await fetch(form.action, {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      });
      setSuccessMessage('Subscribed successfully!');
      form.reset();
      setEmail('');
    } catch (error) {
      console.error('Subscription error:', error);
      setError('There was an issue subscribing.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div id="mc_embed_shell">
      <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css" />
      <div
        id="mc_embed_signup"
        className={css.formContainer}
        style={{ fontFamily: 'Helvetica, Arial, sans-serif', width: '100%' }}
      >
        <form
          action="https://beautyrents.us6.list-manage.com/subscribe/post?u=0530e140d1a3522fe688bd3e1&amp;id=e01c29c204&amp;f_id=0064bde0f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className={css.inputWrapper}>
            <div className={css.inputContainer}>
              <span className={css.emailIcon}>
                <IconCard brand="mail" />
              </span>
              <input
                type="email"
                name="EMAIL"
                id="mce-EMAIL"
                required
                aria-required="true"
                className={`${css.newsletterInput} required email`}
                placeholder="Enter your email address"
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
                aria-invalid={!!error}
              />
            </div>
            <button
              type="submit"
              name="subscribe"
              id="mc-embedded-subscribe"
              className={css.newsletterButton}
              disabled={!!error || !email || loading}
            >
              {loading ? 'SUBSCRIBING...' : 'SUBSCRIBE NOW'}
              <IconCard brand='shareArrow' />
            </button>
          </div>

          {error && <div className={css.error}>{error}</div>}
          {successMessage && <p className={css.success}>{successMessage}</p>}

          {/* MailChimp honeypot field */}
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
          <input
  type="text"
  name="b_0530e140d1a3522fe688bd3e1_e01c29c204"
  tabIndex="-1"
  defaultValue=""
/>
          </div>
        </form>
      </div>

      {/* MailChimp validation scripts */}
      <script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script>
      <script type="text/javascript">{`
        (function($) {
          window.fnames = new Array(); 
          window.ftypes = new Array();
          fnames[0]='EMAIL';ftypes[0]='email';
          fnames[1]='FNAME';ftypes[1]='text';
          fnames[2]='LNAME';ftypes[2]='text';
          fnames[3]='ADDRESS';ftypes[3]='address';
          fnames[4]='PHONE';ftypes[4]='phone';
          fnames[5]='BIRTHDAY';ftypes[5]='birthday';
         fnames[6]='COMPANY';ftypes[6]='text';
        }(jQuery));
        var $mcj = jQuery.noConflict(true);
      `}</script>
    </div>
  );
};
export default MailchimpSubscribe;
